// @flow

import type { AllEffect }             from 'redux-saga/effects';
import { all }                        from 'redux-saga/effects';
import { authSagas }                  from './auth';
import { resourceSagas }              from './resourceSagas';
import topOfPageOnNavigate            from './router/topOfPageOnNavigate';
import watchForUrlPathChanges         from './router/watchForUrlPathChanges';
import { clearSensitiveDataOnLogout } from './session/clearSensitiveDataOnLogout';


export default function* rootSaga(): Generator<AllEffect, void, void> {
  yield all([
    authSagas(),
    resourceSagas(),
    topOfPageOnNavigate(),
    watchForUrlPathChanges(),
    // @todo $FlowFixMe
    clearSensitiveDataOnLogout(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js